module.exports = __webpack_public_path__ + "img/logo_granja.4cc4e045.jpeg";